<template>
  <div class="EnergyInfo" v-loading.fullscreen.lock="loading">
    <el-row style="height: 40px; padding: 5px; margin-top: 10px">
      <el-col :span="6">
        <span>年月：</span>
        <el-date-picker
          v-model="searchData.YearMonth"
          type="month"
          placeholder="月份"
          value-format="yyyyMM"
          format="yyyy-MM"
          :clearable="false"
          style="width: 80%"
          @change="yearChange"
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <div class="cen-top">
      <div style="width: 40%; height: 100%" v-loading="StatisticsLoading">
        <el-row style="height: 50%" :gutter="3">
          <el-col :span="8">
            <el-card>
              <div
                class="wh100 flex-juc-aic flex-wrap"
                style="color: #4472c4; font-size: 20px; font-weight: bold"
              >
                <div
                  class="w100 num tac ellipsis"
                  :title="$tools.momenyFormat(dataStatistics.Electricity)"
                >
                  {{ $tools.momenyFormat(dataStatistics.Electricity) }}
                </div>
                <div class="flex-juc-aic w100 text" style="height: 30px">
                  <div>电耗</div>
                  <img
                    src="@/assets/dian.png"
                    alt=""
                    style="width: 30px; height: 20px; margin-left: 10px"
                  />
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card>
              <div
                class="wh100 flex-juc-aic flex-wrap"
                style="color: #70ad47; font-size: 20px; font-weight: bold"
              >
                <div
                  class="w100 num tac ellipsis"
                  :title="$tools.momenyFormat(dataStatistics.Water)"
                >
                  {{ $tools.momenyFormat(dataStatistics.Water) }}
                </div>
                <div class="flex-juc-aic w100 text" style="height: 30px">
                  <div>水耗</div>
                  <img
                    src="@/assets/shui.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-left: 10px"
                  />
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card>
              <div
                class="wh100 flex-juc-aic flex-wrap"
                style="color: #ffc000; font-size: 20px; font-weight: bold"
              >
                <div
                  class="w100 num tac ellipsis"
                  :title="$tools.momenyFormat(dataStatistics.Gas)"
                >
                  {{ $tools.momenyFormat(dataStatistics.Gas) }}
                </div>
                <div class="flex-juc-aic w100 text" style="height: 30px">
                  <div>气耗</div>
                  <img
                    src="@/assets/qi.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-left: 10px"
                  />
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row style="height: 50%" :gutter="3">
          <el-col :span="8">
            <el-card>
              <div
                class="wh100 flex-juc-aic flex-wrap"
                style="color: #ee6666; font-size: 20px; font-weight: bold"
              >
                <div
                  class="w100 num tac ellipsis"
                  :title="$tools.momenyFormat(dataStatistics.Oil)"
                >
                  {{ $tools.momenyFormat(dataStatistics.Oil) }}
                </div>
                <div class="flex-juc-aic w100 text" style="height: 30px">
                  <div>油耗</div>
                  <img
                    src="@/assets/you.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-left: 10px"
                  />
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card>
              <div
                class="wh100 flex-juc-aic flex-wrap"
                style="color: #ed7d31; font-size: 20px; font-weight: bold"
              >
                <div
                  class="w100 num tac ellipsis"
                  :title="dataStatistics.MaterialCount || 0"
                >
                  {{ dataStatistics.MaterialCount || 0 }}
                </div>
                <div class="flex-juc-aic w100 text" style="height: 30px">
                  <div>备件</div>
                  <img
                    src="@/assets/wuliao.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-left: 10px"
                  />
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card>
              <div
                class="wh100 flex-juc-aic flex-wrap"
                style="color: #7030a0; font-size: 20px; font-weight: bold"
              >
                <div
                  class="w100 num tac ellipsis"
                  :title="$tools.momenyFormat(dataStatistics.Outsourcing)"
                >
                  {{ $tools.momenyFormat(dataStatistics.Outsourcing) }}
                </div>
                <div class="flex-juc-aic w100 text" style="height: 30px">
                  <div>外委</div>
                  <img
                    src="@/assets/waiwei.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-left: 10px"
                  />
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div style="width: 60%; height: 100%">
        <el-row style="height: calc(100%)" :gutter="3" v-loading="InfoLoading">
          <el-col :span="12">
            <el-card style="padding: 10px; position: relative">
              <EchartsDom
                type="pie"
                :data="dataStatistics.ConsumptionProportion"
                :title="{
                  text: `总能耗\n\n${$tools.momenyFormat(dataStatistics.ConsumptionSum)}`,
                  left: 'center',
                  top: 'center',
                  textStyle: { color: '#9b9999', fontSize: 14, fontWeight: 'bold' },
                }"
                :showLegend="false"
                thousandSeparator
                pieDoughnut
                width="100%"
                height="100%"
                :pieInnerRadius="40"
                :pieOuterRadius="60"
              />
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card style="padding: 10px">
              <EchartsDom
                type="pie"
                title="备件消耗"
                :data="dataStatistics.ConsumptionDeviveTypeProportion"
                :showLegend="false"
                thousandSeparator
                pieRadius="60%"
                width="100%"
                height="100%"
              />
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="cen-center" v-loading="ConsumeLoading">
      <el-card style="padding: 10px">
        <div class="section-title">
          <span>设备能耗</span>
          <el-radio-group
            v-model="ConsumeTop"
            style="margin-left: 20px"
            @change="getConsumeList"
          >
            <el-radio-button label="5">Top5</el-radio-button>
            <el-radio-button label="10">Top10</el-radio-button>
            <el-radio-button label="15">Top15</el-radio-button>
          </el-radio-group>
        </div>
        <div class="section-content">
          <EchartsDom
            type="bar2"
            :data="Consumelist"
            width="100%"
            :isStack="false"
            :grid="{
              top: 40,
              left: 60,
              right: 40,
              bottom: 30,
            }"
            :xAxisOption="{
              axisLabel: {
                show: true,
                interval: 0,
                width: 100,
                overflow: 'break',
              },
            }"
            legendPosition="top"
            legendTop="0px"
            labelPosition="top"
            height="100%"
          />
        </div>
        <!-- <EchartsIndex :option="Consumelist" /> -->
      </el-card>
    </div>
    <div class="cen-bottom" v-loading="MaterialLoading">
      <el-card style="padding: 10px">
        <div class="section-title">
          <span>备件消耗</span>
          <el-radio-group
            v-model="MaterialTop"
            style="margin-left: 20px"
            @change="getMaterialList"
          >
            <el-radio-button label="5">Top5</el-radio-button>
            <el-radio-button label="10">Top10</el-radio-button>
            <el-radio-button label="15">Top15</el-radio-button>
          </el-radio-group>
        </div>
        <div class="section-content">
          <EchartsDom
            type="bar"
            barWidth="30%"
            :data="MaterialList || []"
            width="100%"
            :isStack="false"
            :grid="{
              top: 40,
              left: 60,
              right: 40,
              bottom: 30,
            }"
            :isBarColors="true"
            :xAxisOption="{
              axisLabel: {
                show: true,
                interval: 0,
                width: 100,
                overflow: 'break',
              },
            }"
            legendPosition="top"
            legendTop="0px"
            labelPosition="top"
            height="100%"
          />
        </div>
        <!-- <EchartsIndex :option="Consumelist" /> -->
      </el-card>
    </div>
  </div>
</template>
<script>
import EchartsIndex from "@/components/Echarts/index.vue";
import EchartsDom from "@/components/EchartsDom/EchartsDom.vue";
import tools from "@/utils/tools.js";
import moment from "moment";
import { mapState } from "vuex";
export default {
  data() {
    return {
      tools,
      moment,
      loading: false,
      searchData: {
        DeviceType: "",
        BuildingId: "",
        InstallationArea: "",
        YearMonth: "",
      },
      ConsumeTop: "10",
      MaterialTop: "10",
      dataStatistics: {},
      Consumelist: [],
      MaterialList: [],
      StatisticsLoading: false,
      InfoLoading: false,
      ConsumeLoading: false,
      MaterialLoading: false,
    };
  },
  props: {
    search: {
      type: Object,
      default: () => ({}),
    },
    upDataNum: {
      type: Number,
      default: 0,
    },
  },
  components: { EchartsIndex, EchartsDom },
  methods: {
    yearChange() {
      this.getDataStatistics();
      this.getInfoStat();
      this.getConsumeList();
      this.getMaterialList();
    },
    getDataStatistics() {
      this.StatisticsLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceConsumeStatistics", {
          Search: [
            {
              Condition: "DeviceType",
              Keyword: this.devTreeSearch.DeviceType || "",
            },
            {
              Condition: "BuildingId",
              Keyword: this.devTreeSearch.BuildingId || "",
            },
            {
              Condition: "InstallationArea",
              Keyword: this.devTreeSearch.InstallationArea || "",
            },
            {
              Condition: 'TreeType',
              Keyword: this.devTreeSearch.TreeType || 0,
            },
            {
              Condition: "YearMonth",
              Keyword: this.searchData.YearMonth || "",
            },
          ],
        })
        .then((res) => {
          this.StatisticsLoading = false;
          if (res.Success) {
            this.dataStatistics = res.Data;
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    getInfoStat() {
      this.InfoLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceConsumeAnalysis", {
          Search: [
            {
              Condition: "DeviceType",
              Keyword: this.devTreeSearch.DeviceType || "",
            },
            {
              Condition: "BuildingId",
              Keyword: this.devTreeSearch.BuildingId || "",
            },
            {
              Condition: "InstallationArea",
              Keyword: this.devTreeSearch.InstallationArea || "",
            },
            {
              Condition: 'TreeType',
              Keyword: this.devTreeSearch.TreeType || 0,
            },
            {
              Condition: "YearMonth",
              Keyword: this.searchData.YearMonth || "",
            },
          ],
        })
        .then((res) => {
          this.InfoLoading = false;
          if (res.Success) {
            this.dataStatistics = {
              ...res.Data,
            };
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    getConsumeList() {
      this.ConsumeLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceConsumeTopList", {
          Search: [
            {
              Condition: "DeviceType",
              Keyword: this.devTreeSearch.DeviceType || "",
            },
            {
              Condition: "BuildingId",
              Keyword: this.devTreeSearch.BuildingId || "",
            },
            {
              Condition: "InstallationArea",
              Keyword: this.devTreeSearch.InstallationArea || "",
            },
            {
              Condition: 'TreeType',
              Keyword: this.devTreeSearch.TreeType || 0,
            },
            {
              Condition: "YearMonth",
              Keyword: this.searchData.YearMonth || "",
            },
            {
              Condition: "Top",
              Keyword: this.ConsumeTop,
            },
          ],
        })
        .then((res) => {
          this.ConsumeLoading = false;
          if (res.Success) {
            this.Consumelist = res.Data?.Consumelist || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    getMaterialList() {
      this.MaterialLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceConsumeMaterialTopList", {
          Search: [
            {
              Condition: "DeviceType",
              Keyword: this.devTreeSearch.DeviceType || "",
            },
            {
              Condition: "BuildingId",
              Keyword: this.devTreeSearch.BuildingId || "",
            },
            {
              Condition: "InstallationArea",
              Keyword: this.devTreeSearch.InstallationArea || "",
            },
            {
              Condition: 'TreeType',
              Keyword: this.devTreeSearch.TreeType || 0,
            },
            {
              Condition: "YearMonth",
              Keyword: this.searchData.YearMonth || "",
            },
            {
              Condition: "Top",
              Keyword: this.MaterialTop,
            },
          ],
        })
        .then((res) => {
          this.MaterialLoading = false;
          if (res.Success) {
            this.MaterialList = res.Data?.MaterialList || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
  },
  mounted() {},
  created() {
    this.searchData.YearMonth = moment().format("YYYYMM");
    this.getDataStatistics();
    this.getInfoStat();
    this.getConsumeList();
    this.getMaterialList();
  },
  computed: {
    ...mapState(["devTreeSearch"]),
  },
  watch: {
    devTreeSearch() {
      this.getDataStatistics();
      this.getInfoStat();
      this.getConsumeList();
      this.getMaterialList();
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.EnergyInfo {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.cen-top {
  width: 100%;
  height: 200px;

  padding: 5px;
  display: flex;
  ::v-deep .el-card {
    width: 100%;
    height: 100%;
    padding: 10px;
    // border-radius: 10px;
    .el-card__body {
      height: 100%;
      width: 100%;
      padding: 0;
    }
  }
}

.cen-center {
  width: 100%;
  min-height: 230px;
  padding: 5px;
  height: calc(50% - 125px);
  ::v-deep .el-card {
    width: 100%;
    height: 100%;
    // border-radius: 10px;
    .el-card__body {
      height: 100%;
      width: 100%;
      padding: 0;
    }
  }
}
.cen-bottom {
  width: 100%;
  height: calc(50% - 125px);
  padding: 5px;

  ::v-deep .el-card {
    width: 100%;
    height: 100%;
    // border-radius: 10px;
    .el-card__body {
      height: 100%;
      width: 100%;
      padding: 0;
    }
  }
}

::v-deep .el-col {
  height: 100%;
}
::v-deeo .cen-top .el-col {
  padding: 5px;
}
.num {
  font-size: 30px;
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  // margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.section-content {
  width: 100%;
  height: calc(100% - 41px);
}
</style>
